"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./Link"));
var Link_1 = require("./Link");
exports.default = Link_1.default;
//# sourceMappingURL=index.js.map